import { defineAttrs as e } from "../../utils/typed-attrs.js";
var t = {
	content: "",
	group: "block",
	marks: "",
	atom: !0,
	attrs: e({
		type: { default: "messengerCard" },
		canvas: { default: void 0 },
		text: { default: "" },
		messenger_app_id: { default: "" },
		uri: { default: "" }
	}),
	toDOM() {
		return ["div"];
	}
};
//#endregion
export { t as messengerCardSpec };
